export const zIndex = {
  Default: 0,
  CommitStep: 0,
  Button: 1,
  OfferCard: 2,
  ExchangeSidePreview: 2,
  OfferStatus: 5,
  ChatSeparator: 9,
  Carousel: 10,
  LandingTitle: 20,
  Calendar: 30,
  Select: 40,
  Header: 1000,
  Notification: 1001,
  Modal: 2000,
  Popper: 2001,
  Cookie: 2001
};
